import { ProductApiAdapter } from '../adapters/ProductApiAdapter';
import { Product, ProductFilters } from '../models/Product';

export class ProductService {
    constructor(private apiAdapter: ProductApiAdapter) { }

    async getProducts(filters: ProductFilters = {}): Promise<Product[]> {
        // 🎯 Validaciones de negocio
        if (filters.searchTerm && filters.searchTerm.length < 2) {
            throw new Error('El término de búsqueda debe tener al menos 2 caracteres');
        }

        if (filters.limit && filters.limit > 10000) {
            throw new Error('El límite no puede ser mayor a 10,000');
        }

        const products = await this.apiAdapter.getProducts(filters);

        // 🎯 Procesamiento adicional de productos
        return products.map(product => ({
            ...product,
            // Normalizar campo de imagen
            image: product.image_hash || product.image,
            // Normalizar código de producto  
            sku: product.code,
        }));
    }

    async getProductById(id: number): Promise<Product> {
        if (!id || id <= 0) {
            throw new Error('ID de producto inválido');
        }

        const product = await this.apiAdapter.getProductById(id);

        // 🎯 Procesamiento adicional del producto
        return {
            ...product,
            image: product.image_hash || product.image,
            code: product.code,
        };
    }

    // 🎯 Método de utilidad para buscar productos por texto
    async searchProducts(searchTerm: string): Promise<Product[]> {
        if (!searchTerm || searchTerm.trim().length < 2) {
            return [];
        }

        return this.getProducts({ searchTerm: searchTerm.trim() });
    }

    // 🎯 Nuevo: obtener productos paginados para infinite scroll
    async getProductsPaginated(filters: ProductFilters = {}) {
        const pageResponse = await this.apiAdapter.getProductsPaginated(filters);
        // Normalizar productos como en getProducts
        const normalized = pageResponse.products.map(product => ({
            ...product,
            image: product.image_hash || product.image,
            sku: product.code,
        }));
        return {
            products: normalized,
            nextPage: pageResponse.nextPage,
            hasMore: pageResponse.hasMore,
            total: pageResponse.total,
        };
    }
} 